<template>
  <div class="point_application_complete">
    <section class="text_center">
      <h2 class="header_underline">銀行振込決済(収納代行システム)<br>申し込み完了</h2>
      <p class="text_center" v-if="bank">
        お申込みありがとうございます。<br>
        下記口座へお振込みをお願いいたします。
      </p>
      <table v-if="bank" class="table white brown text_left">
        <tr v-if="bank.bank_name">
          <th>銀行名</th>
          <td>{{ bank.bank_name }}</td>
        </tr>
        <tr v-if="bank.branch_name">
          <th>支店名</th>
          <td>{{ bank.branch_name }}</td>
        </tr>
        <tr v-if="bank.branch_code">
          <th>支店名コード</th>
          <td>{{ bank.branch_code }}</td>
        </tr>
        <tr v-if="bank.bank_no">
          <th>口座番号</th>
          <td>{{ bank.bank_no }}</td>
        </tr>
        <tr v-if="bank.bank_type">
          <th>口座種別</th>
          <td>{{ bank.bank_type }}</td>
        </tr>
        <tr v-if="bank.bank_account_name">
          <th>口座名義</th>
          <td>{{ bank.bank_account_name }}</td>
        </tr>
      </table>

      <section class="text_center mt-4">
        <div class="annotation text_left">
          <h4><v-icon color="font_annotation">mdi-alert-circle-outline</v-icon>ご入金時のご注意</h4>
          <p>
            ご入金を頂く際の「ご依頼人名」欄にはご自分のお名前ではなく下記の「<span class="link_sub--text">会員ID</span>」に変更してご入金ください。
          </p>
        </div>
        <table class="table setback white">
          <tr>
            <th>会員ID</th>
            <td>{{ user.user.id }}</td>
          </tr>
        </table>
      </section>

      <p class="mt-4">
        <router-link :to="{ name: 'PointPurchase' }" class="arrow link_main--text">ポイント購入ページに戻る</router-link>
      </p>
    </section>
  </div>
</template>
<script>
export default {
  name: 'PointBankAnotherlaneComplete',
  props: {
    bank: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      user: this.$store.getters.loginUser || null
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    }
  },
  created () {
    if (!this.bank) {
      this.$router.pushIsses({ name: 'PointBankAnotherlaneForm' })
    }
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    }
  }
}
</script>
